import { makeStyles } from '@mui/styles';

const useCompanyRequirementsFormBuilderFormStyle = makeStyles(() => ({
  actionsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default useCompanyRequirementsFormBuilderFormStyle;
